var $676b82e4b56408e6$exports = {};
$676b82e4b56408e6$exports = {
    "Empty": `Tomt`
};


export {$676b82e4b56408e6$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
